import { GeneralService } from './../../services/admin/general.service';
import { CheckInvoicesService } from './../../services/check-invoices/check-invoices.service';
import { Component, OnInit, ViewChild, Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../services/storage.service';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { User } from '../../models/user';
import { ENPOINT } from './../../services/endpoint';
import { GLOBAL } from './../../services/global';
import { NumberFormatStyle } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};


@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    // console.log(this.storage.get('LOCAL_STORAGE'));
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }



}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}


@Component({
  selector: 'app-checkinvoices',
  templateUrl: './check-invoices.component.html',
  styleUrls: ['./check-invoices.component.scss'],
  providers: [GeneralService, CatalogsService, CheckInvoicesService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class CheckInvoicesComponent implements OnInit {
  private basePath;
  public user: User;
  url: string;
  dateCheckInvoices: NgbDateStruct;
  sociedades;
  sociedadOpt = '';
  proveedorOpt = '';
  neaOpt = '';
  ordenCompraOpt = '';
  deOpt = '';
  aOpt = '';
  masterFacturas;
  numFacturasPendientes = 0;
  indicadorIva;
  verDetalle = false;
  multiple = false;
  rol;
  rows = [];
  uuidGuardar;
  sociedadGuardar;
  indicadorIvaGuardar;
  fechaGuardar;
  conceptos: any = [];
  editClicked = null;
  nuevoEstatus;
  docPdf;
  docXml;
  masterFacts = [];
  indexSeleccionado;
  arregloFactura = [];
  mensajeProcesar;
  closeResult: string;
  modalDetalle;
  modalFilters;
  modalMensaje;

  detalle = {
    uuid: '',
    sociedad: '',
    proveedor: '',
    ordencompra: '',
    nea: '',
    importe: 0,
    moneda: '',
    iva: 0,
    indicadorIva: 0,
    tipocambio: 0,
    referencia: '',
    fechaCont: '',
    pdf: '',
    xml: '',
    aacategory: '',
    paymentblock: '',
    cabecera: '',
    estatus: '',
    tipo: '',
    claseDocumento: '',
    textoCabecera: '',
    texto: '',
    operacion: '',
    posicionesFb60: [{
      cuenta_de_mayor: '',
      descripcion: '',
      id: '',
      importe: '',
      impuesto: '',
      uuid: ''
    }]
  };

  salida = {
    masterFactura: []
  };
  salidaTodo = {
    masterFactura: []
  };

  tipoFactura = [
    { id: 'SOC', name: 'Financiera' },
    { id: 'OC', name: 'Logística' }
  ];

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  cuentasm$: Observable<any>;
  cuentasmLoading = false;
  cuentasminput$ = new Subject<string>();

  cecos$: Observable<any>;
  cecosLoading = false;
  cecosinput$ = new Subject<string>();

  flagProcesar = false;
  flagUna = false;
  flagProcesarTodo = false;
  flagDatos;
  flagBuscar;
  flagMensaje;

  busy: boolean = false;
  busyListado: boolean = false;
  busyBuscar: boolean = false;
  busyGuardar: boolean = false;

  toastMessage;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private catalogs: CatalogsService,
    private storageService: StorageService,
    private checkInvoicesService: CheckInvoicesService,
    private toasterService: ToasterService,
    private modalService: NgbModal, @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.translate.get('texto.toastCamposVacios').subscribe(
      text => {
        this.toastMessage = text;
      });
    this.url = GLOBAL.url;
    this.basePath = ENPOINT.url;

    this.getProveedores();
    this.getCuentaDeMayor();
    this.getCecos();

  }


  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    this.modulo();
    this.getMasterFacturas();
    this.getSociedades();
    this.getIndicadorIva();

  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.busy = false;
    this.general.serviceLog('Revisión de facturas').subscribe(
      data => {
        this.busy = true;
      },
      err => {
        this.busy = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }


  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  getSociedades() {
    this.busy = false;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = true;
        this.sociedades = data.sapSociedad;

      },
      err => {
        this.busy = false;
      },
    );
  }

  getCuentaDeMayor() {
    this.cuentasm$ = concat(of([]),
      this.cuentasminput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cuentasmLoading = true),
        switchMap(term =>
          this.catalogs.obtenerCuentaDeMayor(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cuentasmLoading = false)
          ))
      )
    );
  }

  getCecos() {
    this.cecos$ = concat(of([]),
      this.cecosinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.cecosLoading = true),
        switchMap(term =>
          this.catalogs.obtenerCecos(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.cecosLoading = false)
          ))
      )
    );
  }

  getIndicadorIva() {
    this.busy = true;
    this.catalogs.obtenerIndicadoresIva().subscribe(
      data => {
        this.busy = false;
        this.indicadorIva = data.indicador_iva;
      },
      err => {
        this.busy = false;
      },
    );
  }


  getMasterFacturas() {
    this.checkInvoicesService.obtenerMasterFacturasPen(this.sociedadOpt, this.proveedorOpt, this.neaOpt,
      this.ordenCompraOpt, this.deOpt, this.aOpt, this.user.id).subscribe(
        data => {

          this.busyListado = false;
          this.masterFacturas = data.masterFactura; 
          this.numFacturasPendientes = this.masterFacturas.length;

          this.masterFacts.push(this.masterFacturas);

          if (this.masterFacturas.length === 0) {
            this.flagDatos = true;
          } else {
            this.flagDatos = false;
          }

          for (let i = 0; i < this.masterFacts[0].length; i++) {
            this.masterFacts[0][i].selected = false;
          }
        },
        err => {
          this.busy = false;
          this.flagDatos = true;
        },
    );
  }

  selectedFactura(index) {
    this.flagUna = true;
    this.flagProcesarTodo = false;
    for (let i = 0; i < this.masterFacts[0].length; i++) {
      this.masterFacts[0][i].selected = false;
    }
    this.masterFacts[0][index].selected = true;
  }

  detalleFactura(index) {

    this.editClicked = false;
    const arregloPosiciones = [];
    this.arregloFactura = [];
    this.indexSeleccionado = index;
    const mf = this.masterFacts[0];
    this.verDetalle = true;
    this.detalle.uuid = mf[index].uuid;
    this.detalle.sociedad = mf[index].sociedad;
    this.detalle.proveedor = mf[index].proveedor;
    this.detalle.ordencompra = mf[index].ordencompra;
    this.detalle.nea = mf[index].nea;
    this.detalle.importe = mf[index].importe;
    this.detalle.iva = mf[index].iva;
    this.detalle.pdf = mf[index].pdf;
    this.detalle.xml = mf[index].xml;
    this.detalle.moneda = mf[index].moneda;
    this.detalle.indicadorIva = mf[index].indicadorIva;
    this.detalle.tipocambio = mf[index].tipocambio;
    this.detalle.referencia = mf[index].referencia;
    this.detalle.fechaCont = mf[index].fechaCont;
    this.detalle.aacategory = mf[index].aacategory;
    this.detalle.paymentblock = '';
    this.detalle.cabecera = mf[index].cabecera;
    this.detalle.estatus = mf[index].estatus;
    this.detalle.tipo = mf[index].tipo;
    this.detalle.claseDocumento = '';
    this.detalle.textoCabecera = mf[index].textoCabecera;
    this.detalle.texto = mf[index].texto;
    this.detalle.operacion = mf[index].operacion;
    this.detalle.posicionesFb60 = mf[index].posicionesFb60;

    if (this.detalle.posicionesFb60) {

      if (this.detalle.posicionesFb60.length === undefined || this.detalle.posicionesFb60.length === null) {
        arregloPosiciones.push(this.detalle.posicionesFb60);
        this.rows = arregloPosiciones;
      } else if (this.detalle.posicionesFb60.length > 1) {
        this.rows = this.detalle.posicionesFb60;
      }
    }

    this.arregloFactura.push(this.detalle);
  }

  btnEditar() {
    this.editClicked = true;
  }

  btnCancelarEdit() {
    this.editClicked = false;
  }

  estatus(i) {
    const check = (<HTMLInputElement>document.getElementById('estatus' + i)).checked;

    for (let j = 0; j < this.masterFacturas.length; j++) {
      const ch = (<HTMLInputElement>document.getElementById('estatus' + j)).checked;
      if (ch === true) {
        (<HTMLInputElement>document.getElementById('estatus' + j)).checked = false;
      }
    }

    if (check === false) {
      (<HTMLInputElement>document.getElementById('estatus' + i)).checked = true;
    }

  }

  cambiarEstatus(i) {
    const check = (<HTMLInputElement>document.getElementById('estatus' + i)).checked;

    if (check === false) {
      this.nuevoEstatus = 'Pendiente';
      this.flagProcesar = false;
    } else if (check === true) {
      this.nuevoEstatus = 'Aprobado';
      this.flagProcesar = true;
    }

  }

  revisarEstatus() {
    const seleccion = [];
    this.multiple = true;
    for (let i = 0; i < this.masterFacturas.length; i++) {
      const check = (<HTMLInputElement>document.getElementById('estatus' + i)).checked;
      if (check === true) {
        seleccion.push(check);
      }
    }

    let multFact = 0;
    for (let i = 0; i < this.masterFacts[0].length; i++) {
      if (this.masterFacts[0][i].selected) {
        multFact++;
      }

    }

    if (multFact > 1) {
      this.flagProcesarTodo = false;
      this.flagUna = false;
    }
    if (seleccion.length > 1) {
      this.flagProcesarTodo = true;
      this.flagUna = false;
    } else if (seleccion.length === 0) {
      this.flagProcesarTodo = false;
      this.flagUna = false;
    } else {
      this.flagProcesarTodo = false;
      this.flagUna = true;
    }

    if (seleccion.length < this.masterFacturas.length) {
      (<HTMLInputElement>document.getElementById('seleccionarTodo')).checked = false;
    }

  }

  cambiarEstatusTodo() {
    const checkTodo = (<HTMLInputElement>document.getElementById('seleccionarTodo')).checked;

    if (checkTodo === true) {
      for (let i = 0; i < this.masterFacts[0].length; i++) {
        this.masterFacts[0][i].selected = true;
      }
      this.flagProcesarTodo = true;
      this.flagUna = false;
    } else {
      for (let i = 0; i < this.masterFacts[0].length; i++) {
        this.masterFacts[0][i].selected = false;
      }
      this.flagProcesarTodo = false;
    }

  }

  descargaPdf(value) {
    this.docPdf = value; 
    this.getPdf();
  }

  getPdf() {
    const srcFile = this.docPdf;

    if (srcFile) {
      const srcB64 = btoa(srcFile);

      this.checkInvoicesService.downloadPdf(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Factura.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el PDF:', error);
        }
      );
      
    } else {
      // console.log('El registro no contiene archivo PDF.');
    }
  }

  descargaXml(value) {
    this.docXml = value;
    this.getXml();
  }

  getXml() {
    const srcFile = this.docXml;
    
    if (srcFile) {
      const srcB64 = btoa(srcFile);
      
      this.checkInvoicesService.downloadXml(srcB64).subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Factura.xml`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Error al descargar el XML:', error);
        }
      );
     
    } else {
      // console.log('El registro no contiene archivo XML.');
    }
  }

  guardarEdicion() {
    const index = this.indexSeleccionado;
    const fecha = (<HTMLInputElement>document.getElementById('fechaContE')).value;
    this.masterFacts[0][index].fechaCont = fecha;
    this.detalleFactura(index);
    this.editClicked = false;
  }

  guardarEdicion2(rows) {
    this.busyGuardar = true;
    this.conceptos = [];
    let flagSociedad = false;
    let flagConceptos = false;
    this.fechaGuardar = (<HTMLInputElement>document.getElementById('fechaContE')).value;
    this.uuidGuardar = this.detalle.uuid;
    this.indicadorIvaGuardar = '';

    if (this.fechaGuardar === null || this.fechaGuardar === undefined || this.fechaGuardar === '') {
      this.fechaGuardar = this.detalle.fechaCont;
    }

    if (this.detalle.sociedad !== '') {
      this.sociedadGuardar = this.detalle.sociedad;
    } else {
      this.sociedadGuardar = this.sociedadFilter;
    }

    if (this.sociedadGuardar === null || this.sociedadGuardar === undefined || this.sociedadGuardar === '') {
      flagSociedad = false;
    } else {
      flagSociedad = true;
    }

    for (let i = 0; i < rows.length; i++) {
      if (rows[i].cuenta_de_mayor === '' || rows[i].centro_de_coste === '' || rows[i].impuesto === '') {
        flagConceptos = false;
      } else {
        flagConceptos = true;
        const valores = {
          id: rows[i].id,
          cuenta_de_mayor: rows[i].cuenta_de_mayor,
          centro_de_coste: rows[i].centro_de_coste,
          impuesto: rows[i].impuesto,
        };
        this.conceptos.push(valores);
      }
    }

    if (flagSociedad && flagConceptos) {
      this.conceptos = JSON.stringify(this.conceptos);
      this.checkInvoicesService.almacenarPosiciones(this.uuidGuardar, this.sociedadGuardar,
        this.indicadorIvaGuardar, this.conceptos, this.fechaGuardar).subscribe(
          data => {
            this.busyGuardar = false;
            if (data.result.status === 'S') {
              this.toasterService.pop('success', '', data.result.message);
            } else {
              this.toasterService.pop('error', '', data.result.message);
            }
          },
          err => {
            if (err.status === 401) {
              this.storageService.openLogout();
            } 
          }
        );

      this.editClicked = false;

    } else {
      this.toasterService.pop('error', 'ERROR', this.toastMessage);
    }
  }

  cambiarCuentaDeMayor(rows, row, e) {
    row.cuenta_de_mayor = e.cuentaDeMayor;
  }
  cambiarCentroCosto(row, e) {
    row.centro_de_coste = e.centroDeCoste;
  }

  cambiarIndicadorIva(row, e) {
    row.impuesto = e.indicador;
  }

  contabilizar(mensaje) {
    this.busy = true;
    const mf = this.masterFacts[0];
    this.salida.masterFactura = [];

    const objectFacturas = {
      uuid: this.arregloFactura[0].uuid,
      sociedad: this.arregloFactura[0].sociedad,
      proveedor: this.arregloFactura[0].proveedor,
      ordencompra: this.arregloFactura[0].ordencompra,
      nea: this.arregloFactura[0].nea,
      importe: this.arregloFactura[0].importe,
      iva: this.arregloFactura[0].iva,
      aacategory: this.arregloFactura[0].aacategory, // noDoc
      paymentblock: '', // payment block
      cabecera: this.arregloFactura[0].cabecera,
      estatus: 'Aprobado',
      pdf: this.arregloFactura[0].pdf,
      xml: this.arregloFactura[0].xml,
      tipo: this.arregloFactura[0].tipo,
      claseDocumento: '',
      indicadorIva: this.arregloFactura[0].indicadorIva,
      fechaCont: this.masterFacts[0][this.indexSeleccionado].fechaCont,
      textoCabecera: this.arregloFactura[0].textoCabecera,
      moneda: this.arregloFactura[0].moneda,
      texto: this.arregloFactura[0].texto,
      referencia: this.arregloFactura[0].referencia,
      operacion: this.arregloFactura[0].operacion,
      tipocambio: this.arregloFactura[0].tipocambio,
      fechaCarga: this.arregloFactura[0].fechaCarga
    };

    this.salida.masterFactura.push(objectFacturas);

    this.checkInvoicesService.postContabilizar(this.user.id, this.salida).subscribe(
      data => {
        const status = data.result.status;
        this.busy = false;
        this.mensajeProcesar = data.result.message; 
        this.openMensaje(mensaje);
        if (status !== 'E') {
          this.verDetalle = false;
          this.masterFacts = [];
          this.getMasterFacturas();
        }

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );

  }

  contabilizarTodo(mensaje) {
    this.busy = true;
    const mf = this.masterFacts[0];
    this.salidaTodo.masterFactura = [];

    for (let i = 0; i < this.masterFacts[0].length; i++) {
      if (this.masterFacts[0][i].selected) {
        const objectFacturas = {
          uuid: mf[i].uuid,
          sociedad: mf[i].sociedad,
          proveedor: mf[i].proveedor,
          ordencompra: mf[i].ordencompra,
          nea: mf[i].nea,
          importe: mf[i].importe,
          iva: mf[i].iva,
          aacategory: mf[i].aacategory, // noDoc
          paymentblock: '', // payment block
          cabecera: mf[i].cabecera,
          estatus: 'Aprobado',
          pdf: mf[i].pdf,
          xml: mf[i].xml,
          tipo: mf[i].tipo,
          claseDocumento: '',
          indicadorIva: mf[i].indicadorIva,
          fechaCont: this.masterFacts[0][i].fechaCont,
          textoCabecera: mf[i].textoCabecera,
          moneda: mf[i].moneda,
          texto: mf[i].texto,
          referencia: mf[i].referencia,
          operacion: mf[i].operacion,
          tipocambio: mf[i].tipocambio,
          fechaCarga: mf[i].fechaCarga
        };
        this.salidaTodo.masterFactura.push(objectFacturas);
      }
    }

    this.checkInvoicesService.postContabilizar(this.user.id, this.salidaTodo).subscribe(
      data => {
        this.busy = false;
        this.mensajeProcesar = data.result.message; 
        this.openMensaje(mensaje);
        const status = data.result.status;
        if (status !== 'E') {
          this.verDetalle = false;
          this.masterFacts = [];
          this.getMasterFacturas();
        }

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );

  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissMensaje(reason)}`;
    });
  }

  private getDismissMensaje(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else {
      return `with: ${reason}`;
    }
  }

  openEliminar(eliminar) {
    this.modalMensaje = this.modalService.open(eliminar, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissEliminar(reason)}`;
    });
  }

  private getDismissEliminar(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else {
      return `with: ${reason}`;
    }
  }

  eliminarFact(mensaje) {
    this.modalMensaje.close();
    const uuid = this.detalle.uuid;

    this.checkInvoicesService.eliminarFactura(uuid).subscribe(
      data => {
        this.mensajeProcesar = data.result.message;
        this.openMensaje(mensaje);
        this.verDetalle = false;
        this.masterFacts = [];
        this.getMasterFacturas();

      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  openMasDetalle(masDetalle) {
    this.modalDetalle = this.modalService.open(masDetalle, { centered: true });
    this.modalDetalle.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFilters(filtersCheckInv) {

    this.modalFilters = this.modalService.open(filtersCheckInv, { centered: true });
    this.modalFilters.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  proveedorFilter;
  sociedadFilter;
  ordenCompraFilter;
  referenciaFilter;
  neaFilter;
  tipoFacturaFilter;

  buscarFacturas() {
    this.busyBuscar = true;
    let proveedor = this.proveedorFilter; 
    let sociedad = this.sociedadFilter; 
    let ordenCompra = this.ordenCompraFilter; 
    let referencia = this.referenciaFilter;
    let nea = '';
    let tipoFactura = this.tipoFacturaFilter; 
    let fechaI = (<HTMLInputElement>document.getElementById('fechaiOpt')).value;
    let fechaF = (<HTMLInputElement>document.getElementById('fechafOpt')).value;

    if (proveedor === undefined || proveedor === null) {
      proveedor = '';
    }
    if (sociedad === undefined || sociedad === null) {
      sociedad = '';
    }
    if (ordenCompra === undefined || ordenCompra === null) {
      ordenCompra = '';
    }
    if (referencia === undefined || referencia === null) {
      referencia = '';
    }
    if (nea === undefined || nea === null) {
      nea = '';
    }
    if (tipoFactura === undefined || tipoFactura === null) {
      tipoFactura = '';
    }
    if (fechaI === undefined || fechaI === null) {
      fechaI = '';
    }
    if (fechaF === undefined || fechaF === null) {
      fechaF = '';
    }

    if ((proveedor === '') && (sociedad === '') && (ordenCompra === '') && (referencia === '') && (nea === '')
      && (tipoFactura === '') && (fechaI === '') && (fechaF === '')) {
      this.flagBuscar = false;
      this.flagMensaje = true;
    } else {
      this.flagBuscar = true;
      this.flagMensaje = false;
      this.masterFacts = [];
    }

    if (this.flagBuscar === true) {
      this.checkInvoicesService.buscarFacturas(sociedad, proveedor, ordenCompra, fechaI,
        fechaF, nea, tipoFactura, referencia, this.user.id).subscribe(
          data => {
            this.busyBuscar = false;
            this.masterFacturas = data.masterFactura;
            this.masterFacts.push(this.masterFacturas);
            this.modalFilters.close();

            if (this.masterFacturas.length === 0) {
              this.flagDatos = true; 
            } else {
              this.flagDatos = false; 
            }

          },
          err => {
            if (err.status === 401) {
              this.storageService.openLogout();
            } 
          },
      );
    } else {
      this.busyBuscar = false;
    }

  }

  reload() {
    this.busyListado = true;
    this.masterFacts = [];
    this.checkInvoicesService.obtenerMasterFacturasPen('', '', '',
      '', '', '', this.user.id).subscribe(
        data => {
          this.busyListado = false;
          this.masterFacturas = data.masterFactura; 
          this.numFacturasPendientes = this.masterFacturas.length;
          this.masterFacts.push(this.masterFacturas);

          if (this.masterFacturas.length === 0) {
            this.flagDatos = true;
          } else {
            this.flagDatos = false;
          }

        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/check-invoices/check-invoices.component.ts